<template>
    <div>
        <section class="addpoint" v-if="true">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Turnaj ukončen, děkujeme</h2>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section v-else-if="gameStatus === 'need_team'">
            <no-team />
        </section>
        <section class="addpoint" v-else-if="gameStatus === 'download_ready'">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Zaznamenat bod do turnaje</h2>
                    </v-col>
                    <v-col cols="14" offset="1" md="6" offset-md="5">
                        <p>Evidence bodů probíhá přes mobilní aplikaci Cool Ticket.
                            Uložte si prosím kartičku pro zaznamenání bodu.</p>
                    </v-col>
                </v-row>
                <v-btn
                    color="primary"
                    dark
                    @click.stop="startDownload"
                    :loading="downloading"
                    :disabled="downloading"
                >Uložit kartičku</v-btn>
            </v-container>
        </section>
        <section class="addpoint" v-else-if="gameStatus === 'max_points_reached'">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Získáno maximum bodů</h2>
                    </v-col>
                    <v-col cols="14" offset="1" md="6" offset-md="5">
                        <p>Další bod budete moci zaznamenat <span class="semibold">zítra</span></p>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="addpoint" v-else-if="gameStatus === 'registration_only'">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Vítejte</h2>
                    </v-col>
                    <v-col cols="14" offset="1" md="6" offset-md="5">
                        <p>Turnaje startují v <span class="semibold">pondělí 20.7.</span> Do té doby si postavte svůj tým a nainstalujte aplikaci Cool Ticket, přes kterou bude probíhat evidence bodů do turnaje.</p>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <section class="addpoint" v-else-if="gameStatus === 'already_downloaded'">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="10" offset-md="3">
                        <h2 class="section-subtitle">Kartička uložena</h2>
                    </v-col>
                    <v-col cols="14" offset="1" md="6" offset-md="5">
                        <p>Další kartičku si budete moci uložit zase zítra.</p>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <template v-if="gameStatus !== 'need_team' && user">

            <section class="basic-profile-info">
                <v-container>
                    <v-row>
                        <v-col cols="14" offset="1" md="12" offset-md="2">
                            <v-row>
                                <v-col cols="16" offset="0" sm="7" offset-sm="1">
                                    <router-link :to="{ name: 'userSettings' }">
                                        <div class="basic-profile-info__card">
                                            <v-row>
                                                <v-col cols="6" class="basic-profile-info__img">
                                                    <user-avatar-view :settings="user.avatar" />
                                                </v-col>
                                                <v-col cols="10" class="basic-profile-info__info">
                                                    <h2 class="section-smalltitle">{{ user.nickname }}</h2>
                                                    <!--ul>
                                                        <li>jason@email.cz</li>
                                                        <li>+420 789 654 123</li>
                                                    </ul-->
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </router-link>
                                </v-col>
                                <v-col cols="16" offset="0" sm="7" offset-sm="1">
                                    <router-link :to="{ name: 'myTeam' }">
                                        <div class="basic-profile-info__card">
                                            <v-row>
                                                <v-col cols="6" class="basic-profile-info__img">
                                                    <team-blazon-view v-if="user.teamBlazon" :settings="user.teamBlazon" />
                                                    <img v-else src="/img/myteam/Team-Crest.png">
                                                </v-col>
                                                <v-col cols="10" class="basic-profile-info__info">
                                                    <h2 class="section-smalltitle">{{ user.teamName }}</h2>
                                                    <!--ul>
                                                        <li>Hradec Králové</li>
                                                        <li>Kapitán: Captain Jáson</li>
                                                    </ul-->
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </section>

            <current-rank />

        </template>

        <notifications />
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { GAME_STATUS_REQUEST, GAME_DOWNLOAD_VALUABLE_REQUEST } from '../store/actions/game'
    import CurrentRank from '../components/Dashboard/CurrentRank';
    import Notifications from '../components/Dashboard/Notifications';
    import NoTeam from '../components/Team/NoTeam';
    import TeamBlazonView from '../components/TeamBlazon/TeamBlazonView';
    import UserAvatarView from '../components/UserAvatar/UserAvatarView';

    export default {
        components: {
            UserAvatarView,
            TeamBlazonView,
            NoTeam,
            Notifications,
            CurrentRank,
        },
        data () {
            return {
                downloading: false,
            };
        },
        computed: {
            ...mapState ({
                user: state => state.user.user,
                gameStatus: state => state.game.status,
            }),
        },
        created () {
            this.$store.dispatch('game/' + GAME_STATUS_REQUEST);
        },
        methods: {
            async startDownload () {
                try {
                    this.downloading = true;
                    window.location = await this.$store.dispatch('game/' + GAME_DOWNLOAD_VALUABLE_REQUEST);
                } catch (e) {
                    const message = e.response.data.message || 'Došlo k chybě. Zkuste to později.';
                    this.$toast.error(message);
                } finally {
                    this.downloading = false;
                }
            },
        },
    }
</script>
